// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"462":"8e0dfa0b","641":"a896926b"}[chunkId] + ".chunk.js";
};